import React, { cloneElement, useState } from 'react'
import clsx from 'clsx'
import { Popper } from '@mui/material'
import styled from '@emotion/styled'

const useStyles = styled((theme) => ({
  popper: {
    zIndex: 1,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.9em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.9em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
      },
    },
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
}))

function AltPopper({
  id: __id,
  aref,
  placement,
  preventOverflow,
  disablePortal,
  keepMounted,
  modifiers,
  flip,
  transition,
  anchorEl,
  arrow,
  open,
  className,
  children,
}) {
  const classes = useStyles()
  const [arrowRef, setArrowRef] = useState(null)
  const id = open ? __id : null

  const renderChildren = ({ ...popperProps }) => {
    const elements = []
    const $arrow = arrow ? <span key={0} className={classes.arrow} ref={setArrowRef} /> : null

    let element
    if (typeof children === 'function') {
      element = children({
        ...popperProps,
        ...(arrow ? { arrow: $arrow } : {}),
      })
    } else {
      element = children
      if (arrow) {
        elements.push($arrow)
      }
    }
    element = cloneElement(element, arrow ? { key: 1 } : {})
    elements.push(element)
    return elements
  }

  return (
    <Popper
      id={id}
      ref={aref}
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      keepMounted={keepMounted}
      disablePortal={disablePortal}
      transition={transition}
      className={clsx(classes.popper, className)}
      // modifiers={{
      //   flip: {
      //     enabled: flip,
      //   },
      //   arrow: {
      //     enabled: arrow,
      //     element: arrowRef,
      //   },
      //   preventOverflow: {
      //     enabled: preventOverflow !== 'disabled',
      //     boundariesElement: preventOverflow === 'disabled' ? 'scrollParent' : preventOverflow,
      //   },
      //   ...(modifiers || {}),
      // }}
      // anchorOrigin={{
      //   vertical: 'center',
      //   horizontal: 'center',
      // }}
      // transformOrigin={{
      //   vertical: 'center',
      //   horizontal: 'center',
      // }}
    >
      {renderChildren}
    </Popper>
  )
}

export default AltPopper
